<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="환경·에너지 업무 전담조직"
      customThead
      :tableData="[
        { id: 'level', title: '조직레벨', type: 'text', placeholder: '예) 1, 1-1, 1-2', max: 10, focusout: (e, index, id) => checkLevel(e, index, id) },
        { id: 'category', title: '구분', type: 'text', placeholder: '' },
        { id: 'teamname', title: '팀명', type: 'text', placeholder: '' },
        { id: 'photo', title: '사진', type: 'img', placeholder: '' },
        { id: 'name', title: '이름', type: 'text', placeholder: '' },
        { id: 'position', title: '직급', type: 'text', placeholder: '' },
        { id: 'description', title: '업무내용', type: 'textarea', placeholder: '' },
      ]"
      :errorMsg="errorMsg"
      :mobile="['level', 'category', 'teamname']"
      v-model="form.organization"
      class="mt-28px"
    >
      <template #customHead="{allCheckValue, onClickAllCheck, mobile, readonly}">
        <fragment v-if="$viewport.isMobile">
          <tr>
            <th v-if="!board.readonly" class="custom-head">No.</th>
            <th class="custom-head ">
              <div class="flex" style="align-items: center; place-content: center;">
                조직레벨
                <vx-tooltip :html="tooltip"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:20px; color:#7E72F2;" />
                </vx-tooltip>
              </div>
            </th>
            <th class="custom-head">구분</th>
            <th class="custom-head" colspan="2" style="border-right: 1px solid #cdcdcd;">팀명</th>
          </tr>
        </fragment>
        <fragment v-else>
          <tr>
            <th v-if="!board.readonly" class="custom-head">No.</th>
            <th class="custom-head ">
              <div class="flex" style="align-items: center; place-content: center;">
                조직레벨
                <vx-tooltip :html="tooltip"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:20px; color:#7E72F2;" />
                </vx-tooltip>
              </div>
            </th>
            <th class="custom-head">구분</th>
            <th class="custom-head">팀명</th>
            <th class="custom-head">사진</th>
            <th class="custom-head">이름</th>
            <th class="custom-head">직급</th>
            <th class="custom-head">업무내용</th>
          </tr>
        </fragment>




      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import Print from "./Print.vue";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Print,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      organization: {
        $each: {
          level: { required },
        },
      },
    },
  },
  data() {
    return {
      tooltip: `번호 ‘숫자’ 와 기호 ‘-’를 입력하여  조직도 상/하위 구조를 연결합니다.<br/>
예시)<br/>
첫번째 행 : 1<br/>
두번째 행 : 1-1<br/>
세번째 행 : 1-1-1<br/>
네번째 행 : 1-2`,
      form: {
        stdInfo: {},
        fileList: [],

        organization: [],
      },
      errorMsg: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    checkLevel(e, index, id) {
      let value = e.target.value;

      if (!value) {
        this.setErrorMsg(index, id, "레벨을 입력해주세요.");
        return;
      }

      // 같은 레벨의 데이터가 있는지 체크
      const sameLevel = this.form.organization.filter((_o) => _o.level === value);
      if (1 < sameLevel.length) {
        this.setErrorMsg(index, id, "입력된 값과 같은 레벨이 존재합니다.");
        return;
      }

      value = value.split("-");
      if (1 < value.length) {
        // 배열의 마지막을 날린다.
        value.pop();

        // 부모의 레벨을 organization에 검색하여 있는지 확인한다.
        let parentLevel = value.join("-");
        const findLevel = this.form.organization.some((_o) => _o.level === parentLevel);

        // 만약 부모레벨이 없다면 에러를 표기한다.
        if (!findLevel) {
          this.setErrorMsg(index, id, "연결될 상위 레벨이 존재하지 않습니다.");
          return;
        }
      }

      this.setErrorMsg(index, id, "");
    },
    setErrorMsg(index, id, msg) {
      const _errorMsg = JSON.parse(JSON.stringify(this.errorMsg));
      if (!_errorMsg[index]) _errorMsg[index] = {};
      // 표기할 메시지를 errorMsg에 추가
      this.$set(_errorMsg[index], id, msg);
      this.errorMsg = _errorMsg;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.form.organization.map((item, index) => {
          if (!item.level) {
            this.setErrorMsg(index, "level", "레벨을 입력해주세요.");
          }
        });

        return "안전보건업무 전담조직의 모든 조직레벨을 반드시 입력해야 합니다";
      }

      // errorMsg에 데이터가 있는지 체크
      const _errorMsg = this.errorMsg.filter((item, index) => {
        return item && item.level;
      });
      if (0 < _errorMsg.length) return "안전보건업무 전담조직의 모든 조직레벨이 유효하지 않습니다. 다시 확인해 주세요.";
    },
  },
};
</script>

<style scoped lang="scss">
.custom-head {
  border-bottom: 1px solid #cdcdcd;
  padding: 15px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}
</style>
